export default {
  // 画布高度
  telaHeight: {
    type: Number,
    default: null,
  },
  //画布宽度
  telaWidth: {
    type: Number,
    default: null,
  },
  //子元素块之间的间隔
  telaSpace: {
    type: Number,
    default: 20,
  },
  //画布分成多少列
  colNum: {
    type: Number,
    default: 80,
  },
  //画布分成多少行
  rowNum: {
    type: Number,
    default: 45,
  },
  //
  definitionList: {
    type: Array,
    default: () => {
      return []
    },
  },
}
